/**
 * ValuationDetail, read-only náhled uložené valuace + akce (zpět, nová).
 */
import React from 'react';

function fmtCZK(v) {
  if (v === null || v === undefined) return '-';
  return `${Math.round(v).toLocaleString('cs-CZ')} Kč`;
}
function fmtX(v) {
  if (v === null || v === undefined) return '-';
  return `${Number(v).toFixed(2)}×`;
}
function fmtPct(v) {
  if (v === null || v === undefined) return '-';
  return `${Number(v).toFixed(1)} %`;
}
function fmtDate(s) {
  if (!s) return '-';
  try { return new Date(s).toLocaleDateString('cs-CZ', { day: 'numeric', month: 'numeric', year: 'numeric' }); }
  catch { return s; }
}

const TIER_LABEL = { free: 'FREE', rozsirena: 'ROZŠÍŘENÁ', pro: 'PRO', audit: 'AUDIT', komplet: 'KOMPLET' };

export function ValuationDetail({ valuation, onBack, onNew }) {
  const r = valuation?.result_json || {};
  const val = r.valuation || {};
  const met = r.metrics || {};
  const metrics = [
    ['Konzervativní odhad', fmtCZK(val.conservative)],
    ['Optimistický odhad', fmtCZK(val.optimistic)],
    ['EBITDA', fmtCZK(val.ebitda)],
    ['Násobek', fmtX(val.effective_multiple)],
    ['EBITDA marže', fmtPct(met.ebitda_margin_pct)],
    ['Hrubá marže', fmtPct(met.gross_margin_pct)],
  ];

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '1.5rem 1rem', fontFamily: "'Inter', sans-serif" }}>
      <button onClick={onBack} style={back}>← Zpět na valuace</button>

      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem', margin: '1rem 0' }}>
        <h2 style={{ margin: 0, fontFamily: "'Source Serif 4', Georgia, serif", color: 'var(--star-white)', fontSize: '1.4rem' }}>
          {valuation?.company_name || 'Valuace'}
        </h2>
        <span style={badge}>{TIER_LABEL[valuation?.tier] || valuation?.tier}</span>
      </div>
      <div style={{ color: 'var(--text-dim)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
        {valuation?.segment || '-'} · {fmtDate(valuation?.created_at)}
      </div>

      {/* Hlavní číslo */}
      <div style={hero}>
        <div style={{ color: 'var(--text-dim)', fontSize: '0.85rem', marginBottom: '0.3rem' }}>Odhadovaná tržní hodnota</div>
        <div style={{ fontFamily: "'Source Serif 4', Georgia, serif", fontSize: '2.4rem', color: 'var(--purple-glow)', lineHeight: 1.1 }}>
          {fmtCZK(val.total)}
        </div>
        {(val.conservative || val.optimistic) && (
          <div style={{ color: 'var(--text-dim)', fontSize: '0.85rem', marginTop: '0.4rem' }}>
            rozpětí {fmtCZK(val.conservative)}, {fmtCZK(val.optimistic)}
          </div>
        )}
      </div>

      {/* Metriky */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '0.75rem', marginBottom: '1.5rem' }}>
        {metrics.map(([k, v]) => (
          <div key={k} style={cell}>
            <div style={{ color: 'var(--text-dim)', fontSize: '0.78rem' }}>{k}</div>
            <div style={{ color: 'var(--star-white)', fontSize: '1.05rem', fontWeight: 700 }}>{v}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        <button onClick={onNew} style={btnGold}>+ Nová valuace</button>
        <button onClick={onBack} style={btnGhost}>Zpět</button>
      </div>

      <p style={{ color: 'var(--text-dim)', fontSize: '0.78rem', marginTop: '1.5rem' }}>
        Pro úpravu vstupů spusťte novou valuaci. Detailní PRO report a PDF export přibudou s napojením plateb.
      </p>
    </div>
  );
}

const back = { background: 'transparent', border: 'none', color: 'var(--gold)', cursor: 'pointer', fontSize: '0.85rem', padding: 0 };
const badge = {
  padding: '0.2rem 0.7rem', borderRadius: 999, border: '1px solid rgba(0,0,0,0.3)',
  color: 'var(--gold)', fontSize: '0.75rem', fontWeight: 700,
};
const hero = {
  textAlign: 'center', padding: '2rem 1.5rem', marginBottom: '1.5rem', borderRadius: 16,
  border: '1px solid rgba(0,0,0,0.18)',
  background: 'radial-gradient(ellipse 70% 60% at 50% 0%, rgba(107,63,160,0.2) 0%, transparent 70%)',
};
const cell = {
  padding: '0.85rem', borderRadius: 10, background: 'var(--purple-dark,#FFFFFF)',
  border: '1px solid rgba(0,0,0,0.1)',
};
const btnGold = {
  padding: '0.6rem 1.2rem', borderRadius: 8, border: 'none',
  background: 'var(--purple-glow)', color: '#FFFFFF',
  fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer',
};
const btnGhost = {
  padding: '0.6rem 1.2rem', borderRadius: 8, background: 'transparent',
  border: '1px solid rgba(0,0,0,0.3)', color: 'var(--gold)', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer',
};
